const match = <T extends {}>(
  field: keyof T,
  message = 'Campos não batem',
) => (value: string, allValues: { [key in keyof T]: string }) => {
  if (value !== allValues[field]) {
    return message
  }
  return undefined
}

export default match
